var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMelilla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65216 17.3914H24.3478V19.4783H7.65216V17.3914Z",
    fill: "#818085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 11.1304L16 11.8262L21.5652 11.1304V7.79131L19.3391 8.90437L16 5.56519L12.6609 8.90437L10.4348 7.79131V11.1304Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04305 21.5654H6.95605V17.7393L7.65174 16.6957L6.95605 15.6523V13.2175H9.04305V21.5654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0431 21.5654H22.9561V13.2175H25.0431V15.6522L24.3474 16.7132L25.0431 17.7394V21.5654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95605 15.6521H25.043V17.739H6.95605V15.6521Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.3479C12.9313 24.3479 10.4348 21.8514 10.4348 18.7827V11.1306H21.5653V18.7827C21.5652 21.8514 19.0687 24.3479 16 24.3479Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.2609C14.0818 22.2609 12.5215 20.7005 12.5215 18.7827V13.2175H19.478V18.7827C19.478 20.7005 17.9177 22.2609 15.9997 22.2609Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 11.1304H12.5218V13.2173H10.4348V11.1304Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4778 11.1304H21.5647V13.2173H19.4778V11.1304Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4778 15.6521H21.5647V17.739H19.4778V15.6521Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 15.6521H12.5218V17.739H10.4348V15.6521Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9565 11.1304H17.0434V13.2173H14.9565V11.1304Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2607C15.6365 22.2607 15.286 22.2045 14.9565 22.1006V24.2481C15.2947 24.3126 15.6432 24.3477 16 24.3477C16.3567 24.3477 16.7052 24.3126 17.0435 24.2481V22.1006C16.7139 22.2044 16.3635 22.2607 16 22.2607Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5683 19.3472L10.9028 21.0127C11.1915 21.6701 11.6035 22.2613 12.1099 22.7569L13.5849 21.2819C13.0585 20.7734 12.6918 20.1009 12.5683 19.3472Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0972 21.0129L19.4317 19.3474C19.3081 20.101 18.9415 20.7735 18.4152 21.2822L19.8902 22.7572C20.3964 22.2615 20.8085 21.6703 21.0972 21.0129Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMelilla);
export default __webpack_public_path__ + "static/media/flag_melilla.cbac8cd7b9103a5fe83956548abe815d.svg";
export { ForwardRef as ReactComponent };